// flag ids should be in lower kebab case
export default {
  DEBUG: 'debug', // debug mode
  DISABLE_CAVEAT: 'disable-caveat', // don't allow major performance caveats when creating webgl context
};
